<template>
  <div class="PrintPosTkFcf">
    <div v-if="keyMaster == 'cc8a8458a6b9a580a055095006d2de66' || keyMaster == 'b5df5bc0d3cbf62c52817e7bddc09ff3' || keyMaster == 'e9aaa6a6458a982a4b01c253a76ae58d'">
      <div
        v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO RECHAZADO POR HACIENDA
        </h3>
      </div>
      <div
        v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO INVALIDADO POR HACIENDA
        </h3>
      </div>
      <table
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <b>{{
              dataProps.data.user.business != undefined ||
              dataProps.data.user.business != null
                ? dataProps.data.user.business.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        <!--tr>
          <td
            style="
              color: white;
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <img
              v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
              style="max-width: 200px; height: 50px"
              :src="dataProps.data.branch.BranchLogoPath"
              
            />
          </td>
        </tr-->

        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            RAZÓN SOCIAL:
            {{
              dataProps.data.branch.BusinessBillingName !=
                undefined ||
              dataProps.data.branch.BusinessBillingName != null
                ? dataProps.data.branch.BusinessBillingName.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            ACTIVIDAD:
            {{
              dataProps.data.header.EmisorDescActividad !=
                undefined ||
              dataProps.data.header.EmisorDescActividad != null
                ? dataProps.data.header.EmisorDescActividad.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            DIRECCIÓN:
            {{
              dataProps.data.branch.BranchLegalAddress != undefined ||
              dataProps.data.branch.BranchLegalAddress != null
                ? dataProps.data.branch.BranchLegalAddress.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            TÉLEFONO:
            {{
              dataProps.data.branch.BranchPhone != undefined ||
              dataProps.data.branch.BranchPhone != null
                ? dataProps.data.branch.BranchPhone.toUpperCase()
                : ""
            }}
            
            WHATSAPP:
            {{
              dataProps.data.branch.BranchMobile ||
              dataProps.data.branch.BranchManagerMobile ||
              dataProps.data.branch.BranchContactMobile
            }}
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            E-MAIL: {{ dataProps.data.branch.BranchEmail }}
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            NIT: {{ BillingNit }}
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            NRC: {{ BillingNrc }}
          </td>
        </tr>
        <tr v-if="isBranchBilledInfo">
           <td style="
              vertical-align: middle;
              width: 100%; 
              text-align: center;"
              v-html="modifiedBranchBilledInfo()"></td>
        </tr>
      </table>
      <br/><hr/>
      <table
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
              margin: 9pt 0;
            "
          >
            {{ dataProps.data.header.InvoiceType == 'FCF' ? 'FACTURA CONSUMIDOR FINAL' : '' }}
            {{ dataProps.data.header.InvoiceType == 'CCF' ? 'FACTURA CRÉDITO FISCAL' : '' }}
          </td>
        </tr>
        <br/>
        <tr>
          <div style="display: flex; justify-content: space-between;">
            <span>Fecha emisión: {{ dataProps.data.header.InvoiceDate }}</span>
            <span>Hora: {{ dataProps.data.header.IdentificacionHorEmi }}</span>
          </div>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            COD. GENERACIÓN:
            <b>{{ dataProps.data.header.CodigoGeneracion }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            SELLO RECEPCIÓN:
            <b>{{ dataProps.data.header.SelloRecepcion }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            NUM. CONTROL:
            <b style="font-size: 9pt;">{{ dataProps.data.header.NumeroControl }}</b>
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            CORRELATIVO FACTURA:
            <b style="font-size: 9pt;">{{ dataProps.data.header.ID_Invoice }}</b>
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            MÓDELO DE FACTURACIÓN:
            {{
              dataProps.data.dteJson.IdentificacionTipoModelo == 1
                ? "Previo"
                : ""
            }}
            {{
              dataProps.data.dteJson.IdentificacionTipoModelo == 2
                ? "Diferido"
                : ""
            }}
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            TIPO DE TRANSMISIÓN:
            {{
              dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                ? "Normal"
                : ""
            }}
            {{
              dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                ? "Por contingencía"
                : ""
            }}
          </td>
        </tr>
      </table>
      <br/><hr/>
      <table 
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top; 
          text-align: center;"
        >
        <tr>
          <td style="width: 25%;">Cant.</td>
          <td style="width: 25%;">P.<br/>Unit.</td>
          <td style="width: 25%;">Desc.<br/>Por Item</td>
          <td style="width: 25%;">SubTotal</td>
        </tr>
      </table>
      <table
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <!-- Itera sobre cada item en dataProps.data.body -->
        <tr v-for="(item, index) in dataProps.data.body" :key="index">
          <hr/>
          <table style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        ">
          <tr>
            <td colspan="4">
              {{ item.ItemDescription + " " + (parseFloat(item.ItemGravada) > 0 ? "(G)" : "") + (parseFloat(item.ItemExenta) > 0 ? "(E)" : "") + (parseFloat(item.ItemNoSuj) > 0 ? "(NS)" : "") + (parseFloat(item.ItemNoGravada) > 0 ? "(NG)" : "") }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%; text-align: center;">
              {{ item.ItemQuantity }}
            </td>

            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{
                (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice))
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{numberWithCommas(
                  parseFloat(item.ItemDiscount)
                )
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{parseFloat(item.ItemGravada) > 0 ? numberWithCommas(parseFloat(item.ItemGravada)) : ""}}
              {{parseFloat(item.ItemExenta) > 0 ? numberWithCommas(parseFloat(item.ItemExenta)) : ""}}
              {{parseFloat(item.ItemNoSuj) > 0 ? numberWithCommas(parseFloat(item.ItemNoSuj)) : ""}}
              {{parseFloat(item.ItemNoGravada) > 0 ? numberWithCommas(parseFloat(item.ItemNoGravada)) : ""}}
            </td>
          </tr>
          </table>
        </tr>
        
      </table>
      <hr />
      <table
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style=" width: 75%">
            Suma No Sujeta:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoSuj
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Suma Exento:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalExenta
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Suma Gravado:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalGravada
                )
              )
            }}
          </td>
        </tr>
      </table>
      <hr/>
      <table
        style="
          font-size: 9pt;
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style=" width: 75%">
            Suma Total de Operaciones:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotal
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. no sujetas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuNoSuj
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. Exentas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuExenta
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. gravadas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuGravada
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Sub-Total:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotal
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            IVA Retenido (1%):
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaRete1
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            IVA Percibido (1%):
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaPerce1
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Retencion Renta:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceReteRenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceTotalNoGravado > 0">
          <td style=" width: 75%">
            Total otros montos no afectos:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoGravado
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Total a Pagar:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalPagar
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Condicion de Pago:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceStatusDescription }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Efectivo
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{cash}}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Cambio
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{change}}
          </td>
        </tr>
      </table>
      <hr/>
      <table style="
        font-size: 9pt;
        border-collapse: collapse;
        width: 100%;
        vertical-align: top;
      ">
        <tr>
          <td>Valor en Letras: {{ dataProps.data.header.InvoiceTotalLetras }}</td>
        </tr>
      </table>
      <hr/>
      <table style="
        font-size: 9pt;
        border-collapse: collapse;
        width: 100%;
        vertical-align: top;
      ">
        <tr>
          <td style="text-align: center;">
            {{ 
              dataProps.data.header.InvoiceTotalNoGravado > 0 
              ? '(G)- GRAVADO (E)- EXENTO (NS)- NO SUJETO (NG)- OTROS MONTOS NO AFECTOS' 
              : '(G)- GRAVADO (E)- EXENTO (NS)- NO SUJETO' 
            }}
          </td>
        </tr>
      </table>
      <br/>
      <table style="
        font-size: 9pt;
        border-collapse: collapse;
        width: 100%;
        vertical-align: top;
      ">
        <tr>
          <td><b>Responsable por parte del emisor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ dataProps.data.header.InvoiceExtNombEntrega || dataProps.data.header.UserName }}</td>
          <td></td>
        </tr>
        <tr>
          <td><b>N. Documento:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ dataProps.data.header.InvoiceExtDocuEntrega }}</td>
          <td></td>
        </tr>
        <tr>
          <td><b>Responsable por parte del receptor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{
              dataProps.data.header.InvoiceExtNombRecibe ||
              dataProps.data.header.InvoiceName != undefined ||
              dataProps.data.header.InvoiceName != null
                ? dataProps.data.header.InvoiceName.toUpperCase()
                : ""
            }}</td>
          <td></td>
        </tr>
        <tr>
          <td><b>Razon social por parte del receptor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{
              dataProps.data.header.InvoiceName != undefined ||
              dataProps.data.header.InvoiceName != null
                ? dataProps.data.header.InvoiceName.toUpperCase()
                : ""
            }}</td>
            <td></td>
        </tr>
        <tr>
          <td><b>Direccion por parte del receptor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{
              dataProps.data.header.InvoiceAddress != undefined ||
              dataProps.data.header.InvoiceAddress != null
                ? dataProps.data.header.InvoiceAddress.toUpperCase()
                : ""
            }}</td>
            <td></td>
        </tr>
        <tr>
          <td><b>NIT receptor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ dataProps.data.header.InvoiceNIT }}</td>
          <td></td>
        </tr>
        <tr>
          <td><b>DUI receptor:</b></td>
        </tr>
        <tr>
          <td>{{ dataProps.data.header.InvoiceDUI }}</td>
          <td></td>
        </tr>
        <tr>
          <td><b>Entidad de receptor:</b></td>
          <td></td>
        </tr>
        <tr>
          <td>{{ dataProps.data.header.InvoiceEntity }}</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2" 
            style="
              text-align: center;
              vertical-align: top;
            ">
            <img
              ref="qrcode"
              :src="urlQr"
              style="height: 250px"
            />
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceInternalNote && dataProps.data.header.InvoiceInternalNote.length > 0">
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 9pt;
            "
          >
            OBSERVACIONES:
            <b>{{ stripHTML(dataProps.data.header.InvoiceInternalNote) }}</b>
          </td>
        </tr>
      </table>

      <div style="margin-top: 8px;">
        <GuaranteePrintBlock
          :html="dataProps.guaranteeHtml"
          :business-id="dataProps.businessId"
          :branch-id="dataProps.branchId"
          guarantee-type="COMPROBANTE"
          font-size="9pt"
        />
      </div>
      <table
        :style="{fontSize: getFontSizeMd()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style="text-align: center">¡Gracias por su visita!</td>
        </tr>
        <!-- espacio en blanco al finalizar factura de ticket -->
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td style="border-width: 2px; text-overflow: ellipsis; overflow: hidden;">
            <div  
              style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
            >
              ------------------------------------------------------------------------------------------------------
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div v-else> <!-- Ticket para todos los negocios-->
      <div v-if="hideQr || !isProcessed" style="width: 100%;">
        <h3 style="color: red; text-align: center">
          DOCUMENTO SIN VALIDEZ LEGAL
        </h3>
      </div>

      <div
        v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO RECHAZADO POR HACIENDA
        </h3>
      </div>

      <div
        v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO INVALIDADO POR HACIENDA
        </h3>
      </div>

      <table
        :style="{fontSize: getFontSize()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <b>{{
              dataProps.data.user.business != undefined ||
              dataProps.data.user.business != null
                ? dataProps.data.user.business.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        <tr>
          <td
            style="
              color: white;
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <img
              v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
              style="max-width: 200px; height: 50px"
              :src="dataProps.data.branch.BranchLogoPath"
              
            />
          </td>
        </tr>

        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            RAZÓN SOCIAL:
            {{
              dataProps.data.branch.BusinessBillingName !=
                undefined ||
              dataProps.data.branch.BusinessBillingName != null
                ? dataProps.data.branch.BusinessBillingName.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            ACTIVIDAD:
            {{
              dataProps.data.header.EmisorDescActividad !=
                undefined ||
              dataProps.data.header.EmisorDescActividad != null
                ? dataProps.data.header.EmisorDescActividad.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            DIRECCIÓN:
            {{
              dataProps.data.branch.BranchLegalAddress != undefined ||
              dataProps.data.branch.BranchLegalAddress != null
                ? dataProps.data.branch.BranchLegalAddress.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            TÉLEFONO:
            {{
              dataProps.data.branch.BranchPhone != undefined ||
              dataProps.data.branch.BranchPhone != null
                ? dataProps.data.branch.BranchPhone.toUpperCase()
                : ""
            }}
            
            WHATSAPP:
            {{
              dataProps.data.branch.BranchMobile ||
              dataProps.data.branch.BranchManagerMobile ||
              dataProps.data.branch.BranchContactMobile
            }}
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            E-MAIL: {{ dataProps.data.branch.BranchEmail }}
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            NIT: {{ BillingNit }}
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            NRC: {{ BillingNrc }}
          </td>
        </tr>
      </table>
      <hr />
      <table
        :style="{fontSize: getFontSize()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <div :style="{fontSize: getFontSize() }" style="display: flex; justify-content: space-between;">
            <span>Fecha emisión: {{ dataProps.data.header.InvoiceDate }}</span>
            <span>Hora: {{ dataProps.data.header.IdentificacionHorEmi }}</span>
          </div>
        </tr>
        
        <tr>
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
              margin: 9pt 0;
            "
          >
            {{ dataProps.data.header.InvoiceType == 'FCF' ? 'FACTURA CONSUMIDOR FINAL' : '' }}
            {{ dataProps.data.header.InvoiceType == 'CCF' ? 'FACTURA CRÉDITO FISCAL' : '' }}
          </td>
        </tr>
        <tr v-if="!hideQr && isProcessed">
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <img
              ref="qrcode"
              :src="urlQr"
              style="height: 250px; margin: 9pt 0;"
              
            />
          </td>
          
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            COD. GENERACIÓN:
            <b>{{ dataProps.data.header.CodigoGeneracion }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            SELLO RECEPCIÓN:
            <b>{{ dataProps.data.header.SelloRecepcion }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            NUM. CONTROL:
            <b :style="{fontSize: getFontSize()}">{{ dataProps.data.header.NumeroControl }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            CORRELATIVO FACTURA:
            <b :style="{fontSize: getFontSize()}">{{ dataProps.data.header.ID_Invoice }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            MÓDELO DE FACTURACIÓN:
            {{
              dataProps.data.dteJson.IdentificacionTipoModelo == 1
                ? "Previo"
                : ""
            }}
            {{
              dataProps.data.dteJson.IdentificacionTipoModelo == 2
                ? "Diferido"
                : ""
            }}
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            TIPO DE TRANSMISIÓN:
            {{
              dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                ? "Normal"
                : ""
            }}
            {{
              dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                ? "Por contingencía"
                : ""
            }}
          </td>
        </tr>
      </table>
      <hr />
      <table
        :style="{fontSize: getFontSize()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            DATOS DEL RECEPTOR
          </td>
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            RAZÓN SOCIAL:
            <b>{{
              dataProps.data.header.InvoiceName != undefined ||
              dataProps.data.header.InvoiceName != null
                ? dataProps.data.header.InvoiceName.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            DIRECCIÓN:
            <b>{{
              dataProps.data.header.InvoiceAddress != undefined ||
              dataProps.data.header.InvoiceAddress != null
                ? dataProps.data.header.InvoiceAddress.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            NIT: <b>{{ dataProps.data.header.InvoiceNIT }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            DUI: <b>{{ dataProps.data.header.InvoiceDUI }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            ENTIDAD: <b>{{ dataProps.data.header.InvoiceEntity }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            MONEDA:
            <b>{{
              dataProps.data.header.InvoiceCurrency == "$"
                ? "USD"
                : ""
            }}</b>
          </td>
        </tr>
        <tr>
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            ESTADO DE FACTURA:
            <b>{{
              dataProps.data.header.InvoiceStatusDescription
            }}</b>
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceInternalNote && dataProps.data.header.InvoiceInternalNote.length > 0">
          <td
            :style="{fontSize: getFontSize()}"
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
            "
          >
            OBSERVACIONES:
            <b>{{ stripHTML(dataProps.data.header.InvoiceInternalNote) }}</b>
          </td>
        </tr>
      </table>
      <hr />
      <table
        :style="{fontSize: getFontSize()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <!-- Itera sobre cada item en dataProps.data.body -->
        <tr v-for="(item, index) in dataProps.data.body" :key="index">
          <td style="width: 100%">
            <table
              :style="{fontSize: getFontSizeMd()}"
              style="
                width: 100%;
                border-collapse: collapse;
              "
            >
              <tr>
                <td style="text-align: left; width: 50%;">
                  <b>No. Item {{ index + 1 }}</b>
                </td>
                <td style="text-align: right; width: 50%;"></td>
              </tr>
              <tr>
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cantidad
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ item.ItemQuantity }}
                </td>
              </tr>
              <tr v-if="!isElProveedor">
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Código
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ item.PrincipalBarCode || item.ID_Item }}
                </td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="2">
                  <div
                    style="
                      width: 25%;
                      display: inline-block;
                      text-align: left;
                      vertical-align: top;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Descripción:
                  </div>
                  <div
                    style="
                      width: 75%;
                      display: inline-block;
                      text-align: right;
                    "
                  >
                    {{ item.ItemDescription }}
                  </div>
                </td>
              </tr>
              <tr>
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pre. Unitario
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice))
                  }}
                </td>
              </tr>
              <tr v-if="item.ItemDiscount > 0">
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Descuento
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    numberWithCommas(
                      parseFloat(item.ItemDiscount)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="item.ItemExenta > 0">
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas exentas
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    numberWithCommas(
                      parseFloat(item.ItemExenta)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="item.ItemNoSuj > 0">
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas no sujetas
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    numberWithCommas(
                      parseFloat(item.ItemNoSuj)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="item.ItemNoGravada > 0">
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Otros montos no afectos
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    numberWithCommas(
                      parseFloat(item.ItemNoGravada)
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td style="text-align: left; width: 50%;">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas gravadas
                </td>
                <td style="text-align: right; width: 50%;">
                  {{ dataProps.data.header.InvoiceCurrency
                  }}{{
                    numberWithCommas(
                      parseFloat(item.ItemGravada)
                    )
                  }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <hr />
      <table
        :style="{fontSize: getFontSizeMd()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Sub total de ventas
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotalVentas
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Total descuentos
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalDescu
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.TurismoPorAlojamiento > 0">
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Imp. Turismo
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.TurismoPorAlojamiento
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            IVA
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalIva
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Sub total
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotal
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">IVA Retenido</td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaRete1
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
          <td style="text-align: right; width: 80%; padding-right: 4pt;">IVA Percebido</td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaPerce1
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Impuesto sobre la renta
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceReteRenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoGravado)">
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Total otros montos no afectos
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoGravado
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Efectivo
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{cash}}
          </td>
        </tr>
        <tr>
          <td style="text-align: right; width: 80%; padding-right: 4pt;">
            Cambio
          </td>
          <td style="text-align: right; width: 20%">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{change}}
          </td>
        </tr>
      </table>
      
      <table
        :style="{fontSize: getFontSizeLg()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style="text-align: right; width: 75%; padding: 9pt;"><b>Total:</b></td>
          <td style="text-align: right; width: 25%">
            <b
              >{{ dataProps.data.header.InvoiceCurrency
              }}{{
                numberWithCommas(
                  parseFloat(
                    dataProps.data.header.InvoiceTotalPagar
                  )
                )
              }}</b
            >
          </td>
        </tr>
      </table>

      <template 
        v-if="dataProps.data.header.ShowResponsabilitiesInInvoice || dataProps.data.header.InvoiceTotalPagar >= 25000"
        >
        <hr />
        <table
          :style="{fontSize: getFontSize()}"
          style="
            border-collapse: collapse;
            width: 100%;
            vertical-align: top;
          "
        >
          <tr>
            <td><b>Responsable por parte del receptor: </b> {{ dataProps.data.header.InvoiceExtNombEntrega }}</td>
          </tr>
          <tr>
            <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuEntrega }}</td>
          </tr>
          <tr>
            <td><b>Responsable por parte del emisor: </b> {{ dataProps.data.header.InvoiceExtNombRecibe }}</td>
          </tr>
          <tr>
            <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuRecibe }}</td>
          </tr>
        </table>
      </template>

      <div style="margin-top: 8px;">
        <GuaranteePrintBlock
          :html="dataProps.guaranteeHtml"
          :business-id="dataProps.businessId"
          :branch-id="dataProps.branchId"
          guarantee-type="COMPROBANTE"
          font-size="9pt"
        />
      </div>
      
      <table
        :style="{fontSize: getFontSizeMd()}"
        style="
          border-collapse: collapse;
          width: 100%;
          vertical-align: top;
        "
      >
        <tr>
          <td style="text-align: center">¡Gracias por su visita!</td>
        </tr>
        <!-- espacio en blanco al finalizar factura de ticket -->
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td style="border-width: 2px; text-overflow: ellipsis; overflow: hidden;">
            <div  
              style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
            >
              ------------------------------------------------------------------------------------------------------
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { formatNumber } from "../../helpers/money";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
  name: "PrintPosTkFcf2",
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    GuaranteePrintBlock,
  },
  data() {
    return {
      header: null,
      footer: null,
      loading: false,
      numPages: 0,
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      keyMaster: JSON.parse(localStorage.getItem("user"))?.keymaster,
      ticketformat3nstar: JSON.parse(localStorage.getItem("user")).ticketformat3nstar || 0,
      cash: 0,
      change: 0,
    };
  },
  mounted() {
    this.showData()
    this.calculateTotalValues()
  },
  computed: {
    BillingNrc() {
      return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT);
    },
    isBranchBilledInfo(){
      return this.dataProps.data.branch.BranchBilledInfo && 
              this.dataProps.data.branch.BranchBilledInfo != null && 
              this.dataProps.data.branch.BranchBilledInfo != '' && 
              this.dataProps.data.branch.BranchBilledInfo.trim().length > 0;
    },
    isProcessed(){
      return  this.dataProps.data.header.SelloRecepcion && this.dataProps.data.header?.SelloRecepcion.length > 10;
    },
    isMirador(){
      return this.keyMaster == 'f2d93214e58e4c0c63ea915c09240078';
    },
    isElProveedor(){
          return ['27a3c7545503830ee33ce445986e7899', 'c9efbf453194b3947aa53fcfd0ed8d4c'].includes(this.keyMaster);
      },
  },
  watch: {
    "dataProps.show"() {},
  },
  methods: {
    getPrintScale() {     
      if(this.isMirador) return 1.6;
      return 1;
    },
    getFontSize() {
      return `${9 * this.getPrintScale()}pt`;
    },
    getFontSizeMd() {
      return `${10 * this.getPrintScale()}pt`;
    },
    getFontSizeLg() {
      return `${12 * this.getPrintScale()}pt`;
    },
    stripHTML(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    async showData() {
      
        
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          // Crear una nueva fecha en formato "yyyy-mm-dd"
          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          // Generar el código QR y mostrarlo en el elemento con id "qrcode"

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, url) => {
            if (error) {
              console.log("Error al generar el código QR:", error);
              throw error;
            }

            this.urlQr = url;
          });
          await this.getImages();

      
    },
    numberWithCommas(x) {
      if(this.keyMaster === '55652726b965155654981d279f4900bf'){
        return formatNumber(x, 4)
      } 
      return formatNumber(x)
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          // "tributos": null,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          // "tipoItem": 3,
          // "codTributo": null,
          uniMedida: item.ItemMeasureUnit,
          // "numeroDocumento": null,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async getImages() {
      try {
        const logo = this.dataProps.data.branch.BranchLogoPath;
        if (logo && logo !== 'null' && logo !== '') {
          // Usar el endpoint del backend que utiliza downloadFile de googleDriveDownload
          /*const response = await this.$API.utilities.downloadImageAsBase64({ imageUrl: logo });
          if (response && response.imageBase64) {
            this.dataProps.data.branch.BranchLogoPath = response.imageBase64;
          }*/
         '--no usar logo';
         
        }
      } catch (error) {
        console.error('Error al cargar la imagen:', error);
        // Mantener la URL original si hay error
      }
    },
    calculateTotalValues() {
      const invoicePaymentType = this.dataProps.data.header.InvoicePaymentType
      const invoicePayments = this.dataProps.data.invoicePayments || []
      
      if (invoicePaymentType) {
        this.cash = this.dataProps.data.header.InvoiceMontoTotalOperacion;
        this.change = 0
      }

      if (!invoicePaymentType && invoicePayments.length) {
        invoicePayments.forEach((payment) => {
          if (payment?.DescriptionTypePayment == "Billetes y monedas") {
            this.cash += parseFloat(payment.TotalPayment) 
          }

          if (payment?.descriptionPayment == "Billetes y monedas") {
            this.cash += parseFloat(payment.totalPayment) 
          }
        });
        this.change = this.dataProps.data.header.MoneyReturn
        this.cash += this.change
      }
    }
    ,modifiedBranchBilledInfo() {
        const info = this.dataProps.data.branch.BranchBilledInfo
        if (this.isBranchBilledInfo) {
            return info
                .replace(/<p>/g, '')
                .replace(/<\/p>/g, '<br/>')
        }
        return null;
    },
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
